import { Breadcrumb, Button, Card, Col, Divider, Form, Input, message, Popconfirm, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import React, { Component, FormEvent } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Panel } from '../../components/Panel';
import { USER_PROLES_QUERY } from './constant';
import { UserRole } from './type';

interface State {
  currentPage: number;
  variables: {
    id?: number;
    name?: string;
  };
}

interface Props {
  form: WrappedFormUtils;
}
type AllProps = RouteComponentProps & Props;

const deleteUserRolesMutation = gql`
  mutation deleteUserRoles($ids: [ID]!) {
    deleteUserRoles(ids: $ids) {
      id
      name
    }
  }
`;

export class RoleListForm extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      variables: {},
      currentPage: 1,
    };

    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }

  search = (e: FormEvent) => {
    const variables: { name?: string; id?: number } = {};
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const { roleId, roleName } = values;
      if (roleId && roleId !== '') {
        variables.id = roleId;
      }

      if (roleName && roleName !== '') {
        variables.name = roleName;
      }
      this.setState({
        variables,
      });
    });
    e.preventDefault();
  };

  onResetClick = () => {
    this.props.form.resetFields();
  };

  onPageChange = (currentPage: number) => {
    this.setState({
      currentPage,
    });
  };

  expandedRowRender = (record: UserRole) => {
    return (
      <Table dataSource={record.permissions} pagination={false} rowKey={row => `${row.id}`}>
        <Table.Column dataIndex="id" title="权限ID" key="id" />
        <Table.Column dataIndex="description" title="描述" key="description" />
        <Table.Column dataIndex="action" title="行为" key="name" />
        <Table.Column dataIndex="resource" title="来源组件" key="resource" />
      </Table>
    );
  };

  render() {
    const { variables, currentPage } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>角色列表</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Form onSubmit={this.search}>
            <Row gutter={24} type={'flex'} align={'middle'}>
              <Col span={8}>
                <Form.Item label={`用户ID`}>
                  {getFieldDecorator('roleId')(<Input placeholder="请输入用户ID" allowClear />)}
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label={`角色名称`}>
                  {getFieldDecorator('roleName')(<Input placeholder="请输入角色名称" allowClear />)}
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Button icon="search" type="primary" style={{ marginRight: 8 }} htmlType="submit">
                  搜索
                </Button>
                <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                  重置
                </Button>
                <Link to={`/role-permission-role/role/create`}>
                  <Button icon="plus">新增</Button>
                </Link>
              </Col>
            </Row>
          </Form>
        </Card>
        <Panel style={{ marginTop: 10 }}>
          <Query query={USER_PROLES_QUERY} variables={variables} fetchPolicy="cache-and-network">
            {({ loading, error, data }) => {
              if (error) return <div>{error.message}</div>;
              const { userRoles = [] } = data || {};
              return (
                <Table<UserRole>
                  loading={loading}
                  dataSource={userRoles}
                  expandedRowRender={this.expandedRowRender}
                  rowKey={row => `${row.id}`}
                  pagination={{ current: currentPage, onChange: this.onPageChange }}
                >
                  <Table.Column dataIndex="id" title="ID" key="id" />
                  <Table.Column dataIndex="name" title="名称" key="name" />
                  <Table.Column
                    title="操作"
                    key="actions"
                    render={row => (
                      <span>
                        <Button type="primary">
                          <Link to={`/role-permission-role/role/${row.id}/update`}>编辑</Link>
                        </Button>
                        <Divider type="vertical" />
                        <Mutation
                          mutation={deleteUserRolesMutation}
                          variables={{ ids: [Number(row.id)] }}
                          refetchQueries={[{ query: USER_PROLES_QUERY }]}
                        >
                          {(deleteUserRoles, { loading }) => {
                            return (
                              <>
                                <Popconfirm
                                  title="是否确定删除该角色?"
                                  onConfirm={async () => {
                                    try {
                                      await deleteUserRoles();
                                      message.success('删除成功！');
                                    } catch (error) {
                                      message.error(`${error.message}`);
                                    }
                                  }}
                                >
                                  <Button type="primary" loading={loading}>
                                    删除
                                  </Button>
                                </Popconfirm>
                              </>
                            );
                          }}
                        </Mutation>
                      </span>
                    )}
                  />
                </Table>
              );
            }}
          </Query>
        </Panel>
      </div>
    );
  }
}
export const RoleList = Form.create({ name: 'RoleList' })(RoleListForm);



// WEBPACK FOOTER //
// ./src/screens/rolePermission/RoleList.tsx